export default __webpack_public_path__ + "static/logo-3e13880d3920a0878a08c55293f412d7.png";